import {
    Box,
    createTheme,
    Fab,
    Icon,
    Menu,
    Stack,
    ThemeProvider,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { MouseEvent, useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { SpecificColors } from "../constants/ColorConstants";
import { AuthenticationContext } from "../contexts/AuthenticationContext";
import SocketProvider from "../contexts/SocketContext";
import { UserContext } from "../contexts/UserContext";
import Chat from "../features/chat/Chat";
import CustomizedAppBar from "./layouts/CustomizedAppBar";
import CustomizedDrawer from "./layouts/CustomizedDrawer";

export default function PageScaffold(props: { showMenu: boolean }) {
    const user = useContext(UserContext);

    const { requireAuthenticatedUser } = useContext(AuthenticationContext);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState<HTMLElement>(null);
    const open = Boolean(anchorEl);

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

    const toggleDrawer = () => {
        setDrawerOpen(!drawerOpen);
    };

    useEffect(() => {
        requireAuthenticatedUser();
    }, []);

    if (!user) {
        return <></>;
    }

    const handleOpenChatBox = (ev: MouseEvent<HTMLButtonElement>) => {
        if (open) {
            setAnchorEl(null);
        } else {
            setAnchorEl(ev.currentTarget);
        }
    };

    const aiButtonTheme = createTheme({
        typography: {
            fontFamily: "IranSans",
            fontSize: 12,
        },
        palette: {
            primary: {
                light: SpecificColors.Purple2,
                main: SpecificColors.Purple2,
                dark: SpecificColors.Purple2,
                contrastText: SpecificColors.Purple2,
            },
        },
        components: {
            MuiIcon: {
                styleOverrides: {
                    root: {
                        fontSize: "35px",
                        lineHeight: "38px",
                    },
                },
            },
        },
    });

    return (
        <Box>
            {/* show menu if the route requires  */}
            {props.showMenu ? (
                <>
                    <CustomizedAppBar toggleDrawer={toggleDrawer} />
                    <CustomizedDrawer
                        toggleDrawer={toggleDrawer}
                        drawerOpen={drawerOpen}
                    />
                </>
            ) : (
                <></>
            )}

            <Box
                sx={{ mt: props.showMenu ? 8 : 2, mb: 2, position: "relative" }}
            >
                <Outlet />
            </Box>

            <ThemeProvider theme={aiButtonTheme}>
                <Fab
                    sx={{
                        position: "fixed",
                        right: { md: "24px", xs: "auto" },
                        left: { xs: "24px", md: "auto" },
                        bottom: "24px",
                        "@media print": {
                            display: "none",
                        },
                    }}
                    onClick={(e) => handleOpenChatBox(e)}
                    color="secondary"
                    variant={isSmallScreen ? "circular" : "extended"}
                >
                    {isSmallScreen ? (
                        <>
                            {open === true ? (
                                <Icon fontSize="large">close</Icon>
                            ) : (
                                <Icon fontSize="large">contact_support</Icon>
                            )}
                        </>
                    ) : (
                        <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                        >
                            <Typography variant="subtitle1">
                                دستیار هوش مصنوعی
                            </Typography>
                            {open === true ? (
                                <Icon fontSize="large">close</Icon>
                            ) : (
                                <Icon fontSize="large">contact_support</Icon>
                            )}
                        </Stack>
                    )}
                </Fab>
            </ThemeProvider>
            <Menu
                onClose={handleOpenChatBox}
                anchorOrigin={{ horizontal: "left", vertical: "top" }}
                transformOrigin={{ vertical: "bottom", horizontal: "left" }}
                anchorEl={anchorEl}
                open={open}
            >
                <SocketProvider>
                    <Chat />
                </SocketProvider>
            </Menu>
        </Box>
    );
}
